import api from "./api";
import { API_URL_VERSION } from "../constants/environment";
import { ENDPOINT_TRAFFIC_VIOLATIONS_NO_RECORD } from "./trafficViolationService";

export const ENDPOINT_VEHICLES = API_URL_VERSION + "consulta-veiculos";
export const ENDPOINT_VEHICLES_BY_PLATE = ENDPOINT_VEHICLES + "/placa";
export const ENDPOINT_VEHICLES_NO_RECORD = ENDPOINT_VEHICLES + "/nada-consta";

export const vehicleService = {
  findByPlate: async (plate) => {
    try {
      const response = await api.get(`${ENDPOINT_VEHICLES_BY_PLATE}/${plate}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "vehicle.messages.errors.find";
    }
  },

  printNoRecord: async (plate) => {
    try {
      const response = await api.get(`${ENDPOINT_VEHICLES_NO_RECORD}/${plate}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "vehicle.messages.errors.print-no-record";
    }
  },
};
